export enum CrudActionEnum {
  CREATE = 'CREATE',
  READ = 'READ',
  UPDATED = 'UPDATED',
  DELETE = 'DELETE'
}
